// this file is generated by update_shopify_store_data.py at 2026-06-22 20:29:01.304283
var courses = [
    {
        "course_id": "CB47C053-2648-EF11-998E-005056A70840",
        "course_version": 1,
        "name": "ANA: Putting the Nursing Scope and Standards into Practice",
        "course_type": 1,
        "author_information": "",
        "description": "Overview\r\nNursing is, by definition, a profession of caring. Your nursing practice must follow Scope and Standards that range from competent clinical knowledge to navigating complex healthcare systems. You advocate for your patients and colleagues, innovate solutions when systems fail, and serve as leaders throughout your career.\r\nThe Nursing Scope and Standards of Practice (4th Edition) act as the guide for you in your professional capacity as a nurse, from the bedside to the C-suite. Nurses like you may find it challenging to integrate the who, what, where, when, why, and how of professional nursing practice every day. This online course, developed by members of the Scope and Standards 4th Edition Workgroup, provides you with the context and opportunities to reflect so you can:\r\n\r\nDefine nursing\r\nUnderstand the scope of your practice to support your autonomy to practice at the full extent of your license\r\nDescribe how to incorporate the Scope and Standards of Nursing at each level of nursing\r\nExplain how the profession of nursing integrates both art and science as a core foundation into its practice\r\nIdentify ways to overcome the barriers of implementing the Scope and Standards into your daily practice\r\nDiscover ways you can impact the future of nursing\r\n\r\nNurses at all stages of their education and careers, from the newly licensed RN to DNP, will benefit from this course.",
        "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<br />\r\nNurses will apply, analyze, and evaluate:\r\nThe concepts and relevance of the Nursing Scope and Standards to their current nursing practice",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4FF3BFFA-D08C-EB11-80DF-005056B134EC",
                "course_category_name": "Bloodborne Pathogens",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CD33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Infection Control",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "01DE6ED9-D88C-EB11-80DF-005056B134EC",
                "course_category_name": "Hand Hygiene",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "306B4D00-C749-E611-832F-005056B17E48",
                "course_category_name": "Environmental Services",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 11.3,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];